import React from 'react';
import { getData } from '../../../data/followup/selectors/followup';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import isEmpty from 'lodash/isEmpty';
import {generate} from "../../../routing/routes";
import { DocumentLine } from "../../shared/components/DocumentLine";

const DownloadQuotationButton = ({ data, t }) => {
    if ('quotation' !== data.type || isEmpty(data.numbering)) {
        return null;
    }

    return <DocumentLine
        href={`/api/reservation-followup/${data.reference}/documents/quotation`}
        label={t('followup.quotation_download_1')  + ' ' + t('followup.quotation_download_2')}/>
};

const DownloadReservationButton = ({ data, t }) => {
    if ('reservation' !== data.type) {
        return null;
    }

    return <DocumentLine
        href={`/api/reservation-followup/${data.reference}/documents/reservation`}
        label={t('followup.reservation_download_1')  + ' ' + t('followup.reservation_download_2')}/>
};

const DownloadCarTransportContractButton = ({ data, t }) => {
    if ('reservation' !== data.type) {
        return null;
    }

    return <DocumentLine
        href={`/documents/contrat-de-convoyage-de-vehicule.pdf`}
        label={t('followup.car_transport_download')}/>
};

const DownloadInvoiceButton = ({ data, t }) => {
    if ('reservation' !== data.type || isEmpty(data.invoice)) {
        return null;
    }

    return <DocumentLine
        href={generate('customer_reservation_invoice', { reference: data.reference, invoiceId: data.invoice })}
        label={t('followup.invoice_download')}/>
};

const Documents = () => {
    const data = useSelector(state=>getData(state.followup))
    const {t} = useTranslation();

    return (
        <div className="p-5">
            <div className="overflow-hidden bg-white shadow sm:rounded-md">
                <ul role="list" className="divide-y divide-gray-200">
                    <DownloadInvoiceButton t={t} data={data}/>
                    {data.status != 'cancelled' && <DownloadQuotationButton t={t}  data={data}/>}
                    {data.status != 'cancelled' && <DownloadReservationButton t={t}  data={data}/>}
                    <DocumentLine href={"/documents/etiquettes-bagages.pdf"} label={`${t("account_button.download_labels")}`} />
                    {data.hasCarTransport && <DownloadCarTransportContractButton t={t} data={data}/>}
                    {data.hasCarTransport && <DocumentLine href={"/documents/plan-malpas-stationnement.pdf"} label={`${t("account_button.download_map")}`} />}
                    <DocumentLine href={"/documents/minimalle.pdf"} label={`${t("account.download")} "La petite Malle illustrée"`} />
                </ul>
            </div>
        </div>
    );
};
export default Documents;